import DSRouterInstance from './DSRouter'
export default DSRouterInstance
